import { useState } from "react";

import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { ModalBox } from "../boxes";
import { Icon, Button, TextInput } from "../base";
import CopyIcon from "../../assets/images/icons/copy.svg";
import RemoveIcon from "../../assets/images/icons/remove.svg";
import SuccessIcon from "../../assets/images/icons/success-icon.svg";

const useStyles = makeStyles((theme) => ({
  labelStyle: {
    fontSize: 16,
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: theme.spacing(3.75),
    marginBottom: theme.spacing(0.5),
  },
  inputContainer: {
    margin: 0,
    padding: "2px 0",
  },
  successBlock: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "#E7FCDC",
    height: 80,
    width: 80,
  },
}));

export const ShareBoardModal = ({ onClose }) => {
  const classes = useStyles();
  const [isSuccessContent, setSuccessContent] = useState(false);

  const sendInvite = () => {
    setSuccessContent(true);
    setTimeout(() => onClose(), 2000);
  };

  return (
    <ModalBox width={800}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h2">Share Board</Typography>
        {!isSuccessContent ? (
          <Icon src={RemoveIcon} hoverable onClick={onClose} />
        ) : null}
      </Grid>

      {!isSuccessContent ? (
        <>
          <Typography className={classes.labelStyle}>
            Share it with anyone you like:
          </Typography>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={9}>
              <TextInput
                containerStyle={classes.inputContainer}
                fullWidth
                placeHolder="email, comma separated"
              />
            </Grid>
            <Grid item xs={3}>
              <Button text="SEND INVITE" onClick={() => sendInvite()} />
            </Grid>
          </Grid>

          <Typography className={classes.labelStyle}>
            OR Share a link:
          </Typography>
          <Grid
            container
            alignItems="center"
            spacing={2}
            style={{ marginBottom: 40 }}
          >
            <Grid item xs={9}>
              <TextInput
                containerStyle={classes.inputContainer}
                fullWidth
                value="https://carboonzero/prass/customername.com"
                helperText="Everyone with this link will be able to read and share this file."
                endAdornmentIcon={<Icon src={CopyIcon} hoverable />}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          direction="column"
          style={{ height: "282.54px" }}
        >
          <Box className={classes.successBlock}>
            <Icon src={SuccessIcon} />
          </Box>
          <Typography variant="subtitle1" style={{ marginTop: 10 }}>
            Invitation was successfully sent
          </Typography>
        </Grid>
      )}
    </ModalBox>
  );
};
